var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-web-view',_vm._g({ref:"webviewContainer",class:{'uni-webview--fullscreen':_vm.fullscreen}},_vm.$listeners),[_c('v-uni-resize-sensor',{ref:"sensor",on:{"resize":_vm._resize}})],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }